import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/freelance-rate-calculator/FreelanceRateContent.tsx");
